import $ from 'jquery';
import mapStyles from './map-styles';

export default () => {

  function tooltipTpl(information) {
    let tpl = '';
    for (let k = 0; k < information.length; k += 1) {
      const address = information[k].address ? 
        `<address class="info-window__item info-window__address">
          <svg xmlns="http://www.w3.org/2000/svg" width="27" height="34" viewBox="0 0 27 34"><path d="M961.493,975a13.64,13.64,0,0,0-13.253,16.187c0.007,0.05.035,0.2,0.092,0.457a13.5,13.5,0,0,0,.9,2.687c1.454,3.457,4.65,8.769,11.665,14.459a0.962,0.962,0,0,0,1.2,0c7.007-5.69,10.211-11,11.665-14.459a13.356,13.356,0,0,0,.9-2.687c0.057-.257.085-0.407,0.092-0.457a14.17,14.17,0,0,0,.24-2.559A13.6,13.6,0,0,0,961.493,975Zm11.376,15.852c0,0.015-.007.029-0.007,0.043-0.007.036-.029,0.143-0.064,0.307v0.014a11.375,11.375,0,0,1-.783,2.324c-0.007.007-.007,0.021-0.014,0.028-1.32,3.158-4.213,7.972-10.508,13.232-6.3-5.26-9.188-10.074-10.508-13.232-0.007-.007-0.007-0.021-0.014-0.028a12.128,12.128,0,0,1-.783-2.324V991.2c-0.043-.164-0.057-0.271-0.064-0.307,0-.014-0.007-0.028-0.007-0.05A11.586,11.586,0,1,1,972.869,990.852Zm-11.376-10.727a8.653,8.653,0,1,0,8.567,8.653A8.624,8.624,0,0,0,961.493,980.125Zm0,15.382a6.729,6.729,0,1,1,6.662-6.729A6.7,6.7,0,0,1,961.493,995.507Z" transform="translate(-948 -975)"/></svg>
          ${information[k].address}
        </address>`
        : '';

      const email = information[k].email ? 
        `<div class="info-window__item info-window__email">
          <svg xmlns="http://www.w3.org/2000/svg" width="34" height="26" viewBox="0 0 34 26"><path d="M1392.85,979h-25.69a4.169,4.169,0,0,0-4.16,4.178v17.642a4.168,4.168,0,0,0,4.16,4.18h25.68a4.168,4.168,0,0,0,4.16-4.18V983.185A4.166,4.166,0,0,0,1392.85,979Zm2.26,21.82a2.273,2.273,0,0,1-2.26,2.27h-25.69a2.266,2.266,0,0,1-2.26-2.27V983.185a2.265,2.265,0,0,1,2.26-2.269h25.68a2.265,2.265,0,0,1,2.26,2.269v17.635h0.01Zm-10.67-9.039,8.32-7.494a0.97,0.97,0,0,0,.07-1.35,0.959,0.959,0,0,0-1.35-.07l-11.46,10.342-2.24-2.008a0.021,0.021,0,0,1-.01-0.021,1.159,1.159,0,0,0-.16-0.134l-9.1-8.186a0.955,0.955,0,1,0-1.27,1.427l8.42,7.557-8.38,7.882a0.975,0.975,0,0,0-.05,1.354,1.012,1.012,0,0,0,.7.3,0.948,0.948,0,0,0,.65-0.25l8.5-8,2.31,2.071a0.94,0.94,0,0,0,.63.24,0.954,0.954,0,0,0,.64-0.247l2.37-2.135,8.45,8.07a0.954,0.954,0,0,0,.66.26,0.938,0.938,0,0,0,.69-0.29,0.963,0.963,0,0,0-.04-1.352Z" transform="translate(-1363 -979)"/></svg>
          <a href="mailto:${information[k].email}">${information[k].email}</a>
        </div>` : '';

      const phonesList = information[k].phones.map((phone) => {
        const phoneLink = phone.replace(/\s+/g,'');
        return `<a href="tel:${phoneLink}" class="info-window__item info-window__phone">${phone}</a>`;
      }).join('');
      tpl += `<div class="info-window">
                <div class="info-window__img">
                  <img src="${information[k].img}" width="100" height="100" alt="${information[k].name}" title="${information[k].name}">
                </div>
                <div class="info-window__holder">
                  <div class="info-window__item info-window__name">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="20" height="23" viewBox="0 0 20 23"><path d="M19.765,20.423 C19.716,20.547 19.623,20.652 19.511,20.723 C19.365,20.814 15.865,23.000 10.007,23.000 C4.150,23.000 0.649,20.819 0.503,20.723 C0.386,20.652 0.298,20.547 0.250,20.423 C-0.008,19.785 -0.004,18.513 0.001,18.266 C0.001,18.261 0.001,18.256 0.001,18.251 C0.006,18.213 0.006,18.175 0.006,18.132 C0.035,17.194 0.099,14.989 2.212,14.279 C2.226,14.274 2.241,14.270 2.261,14.265 C4.466,13.717 6.282,12.479 6.302,12.465 C6.599,12.260 7.008,12.331 7.217,12.622 C7.427,12.912 7.354,13.312 7.057,13.517 C6.974,13.569 5.036,14.894 2.611,15.503 C1.477,15.899 1.350,17.084 1.316,18.170 C1.316,18.213 1.311,18.251 1.311,18.289 C1.301,18.718 1.335,19.380 1.413,19.761 C2.207,20.199 5.318,21.719 10.002,21.719 C14.706,21.719 17.798,20.204 18.586,19.766 C18.664,19.385 18.693,18.723 18.689,18.294 C18.684,18.256 18.684,18.218 18.684,18.175 C18.650,17.089 18.523,15.903 17.389,15.508 C14.964,14.898 13.026,13.579 12.943,13.522 C12.646,13.317 12.573,12.917 12.783,12.626 C12.992,12.336 13.401,12.264 13.698,12.469 C13.717,12.484 15.543,13.722 17.739,14.270 C17.754,14.274 17.773,14.279 17.788,14.284 C19.901,14.989 19.964,17.194 19.994,18.137 C19.994,18.180 19.998,18.218 19.998,18.256 C19.998,18.261 19.998,18.266 19.998,18.270 C20.003,18.518 20.008,19.790 19.765,20.423 ZM10.070,12.393 C10.056,12.393 10.036,12.393 10.022,12.393 C10.012,12.393 10.002,12.393 9.993,12.393 C9.963,12.393 9.939,12.393 9.915,12.393 C8.488,12.369 7.334,11.879 6.487,10.940 C4.612,8.873 4.924,5.330 4.958,4.992 C5.080,2.434 6.326,1.219 7.349,0.653 C8.366,0.086 9.428,-0.000 9.968,-0.000 L9.997,-0.000 C10.002,-0.000 10.012,-0.000 10.017,-0.000 L10.051,-0.000 C11.034,0.019 11.916,0.248 12.671,0.672 C13.683,1.238 14.910,2.453 15.032,4.992 C15.066,5.330 15.378,8.873 13.503,10.940 C12.651,11.879 11.497,12.369 10.070,12.393 ZM13.727,5.111 C13.722,5.101 13.722,5.087 13.722,5.072 C13.571,1.843 11.336,1.319 10.022,1.291 C10.007,1.291 9.993,1.291 9.983,1.291 L9.963,1.291 C8.902,1.291 6.424,1.657 6.263,5.072 C6.263,5.082 6.258,5.096 6.258,5.111 C6.253,5.139 5.922,8.392 7.466,10.088 C8.074,10.764 8.897,11.098 9.968,11.107 C9.978,11.107 9.983,11.107 9.993,11.107 C10.002,11.107 10.007,11.107 10.017,11.107 C11.093,11.098 11.911,10.764 12.524,10.088 C14.073,8.383 13.732,5.144 13.727,5.111 Z" class="cls-1"/></svg>
                    ${information[k].name}
                  </div>
                  <div class="info-window__phones-wrap">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="33" height="33" viewBox="0 0 33 33"><path d="M32.218,15.630 C32.162,15.637 32.114,15.644 32.058,15.644 C31.604,15.644 31.207,15.323 31.130,14.863 C30.579,11.618 29.044,8.658 26.687,6.304 C24.329,3.957 21.365,2.417 18.114,1.867 C17.598,1.777 17.256,1.296 17.340,0.781 C17.431,0.272 17.912,-0.076 18.421,0.014 C22.062,0.634 25.376,2.348 28.012,4.980 C30.649,7.613 32.365,10.921 32.985,14.557 C33.076,15.065 32.727,15.553 32.218,15.630 ZM18.163,5.997 C20.374,6.373 22.390,7.418 23.988,9.013 C25.585,10.608 26.631,12.621 27.008,14.829 C27.091,15.344 26.750,15.832 26.233,15.915 C26.178,15.922 26.129,15.929 26.073,15.929 C25.620,15.929 25.222,15.609 25.145,15.149 C24.832,13.324 23.974,11.667 22.648,10.343 C21.323,9.020 19.663,8.156 17.835,7.850 C17.319,7.766 16.984,7.272 17.075,6.763 C17.166,6.255 17.647,5.914 18.163,5.997 ZM11.914,12.203 C11.397,12.725 10.867,13.268 10.295,13.791 C10.721,14.731 11.307,15.657 12.179,16.758 C13.978,18.966 15.854,20.672 17.919,21.982 C18.121,22.107 18.359,22.225 18.610,22.351 C18.784,22.441 18.965,22.532 19.147,22.629 L21.351,20.435 C22.055,19.732 22.878,19.363 23.736,19.363 C24.601,19.363 25.417,19.739 26.094,20.442 L29.923,24.280 C30.628,24.976 30.998,25.805 30.998,26.669 C30.998,27.526 30.635,28.361 29.944,29.079 C29.644,29.392 29.337,29.692 29.037,29.977 C28.598,30.402 28.180,30.799 27.817,31.238 C27.810,31.252 27.796,31.259 27.789,31.273 C26.729,32.422 25.376,33.000 23.764,33.000 C23.625,33.000 23.471,32.993 23.325,32.986 C20.932,32.833 18.791,31.934 17.187,31.175 C12.988,29.148 9.312,26.272 6.257,22.629 C3.739,19.607 2.051,16.786 0.921,13.742 C0.460,12.502 -0.139,10.608 0.028,8.574 C0.140,7.314 0.649,6.227 1.542,5.336 L3.913,2.947 C3.920,2.940 3.920,2.940 3.927,2.933 C4.624,2.264 5.448,1.909 6.299,1.909 C7.150,1.909 7.959,2.264 8.635,2.933 C9.089,3.351 9.528,3.796 9.947,4.228 C10.156,4.451 10.379,4.674 10.595,4.890 L12.499,6.791 C13.964,8.254 13.964,10.148 12.499,11.611 C12.304,11.806 12.109,12.008 11.914,12.203 ZM11.174,8.121 L9.270,6.220 C9.047,5.990 8.824,5.767 8.607,5.545 C8.182,5.106 7.777,4.695 7.352,4.298 C7.345,4.291 7.338,4.284 7.331,4.277 C7.108,4.054 6.752,3.789 6.312,3.789 C5.957,3.789 5.594,3.964 5.252,4.284 L2.874,6.659 C2.295,7.237 1.981,7.913 1.911,8.727 C1.807,10.002 2.044,11.353 2.692,13.087 C3.746,15.929 5.336,18.576 7.715,21.438 C10.595,24.872 14.062,27.581 18.010,29.490 C19.454,30.179 21.379,30.987 23.450,31.119 C23.555,31.126 23.667,31.126 23.771,31.126 C24.859,31.126 25.689,30.771 26.394,30.019 C26.826,29.511 27.287,29.058 27.740,28.626 C28.040,28.333 28.319,28.069 28.591,27.776 C29.303,27.038 29.303,26.307 28.584,25.596 L24.741,21.759 C24.734,21.752 24.734,21.752 24.727,21.745 C24.511,21.508 24.155,21.236 23.722,21.236 C23.283,21.236 22.906,21.522 22.669,21.759 L20.284,24.141 C20.165,24.259 19.802,24.621 19.223,24.621 C18.993,24.621 18.770,24.565 18.533,24.447 C18.505,24.433 18.477,24.412 18.449,24.398 C18.247,24.273 18.010,24.155 17.759,24.029 C17.480,23.890 17.187,23.744 16.901,23.563 C14.662,22.149 12.632,20.303 10.707,17.935 L10.700,17.928 C9.640,16.584 8.942,15.456 8.447,14.258 C8.440,14.237 8.433,14.216 8.426,14.195 C8.300,13.798 8.189,13.213 8.789,12.614 C8.796,12.600 8.810,12.593 8.824,12.579 C9.430,12.036 9.988,11.479 10.574,10.880 C10.777,10.685 10.972,10.483 11.174,10.281 C11.914,9.542 11.914,8.860 11.174,8.121 Z" class="cls-1"/></svg>                  
                    <div class="info-window__phones-list">${phonesList}</div>
                  </div>
                  ${email}
                  ${address}
                </div>
              </div>`
    }    
    return `<div class="info-window__list">${tpl}</div>`;
  }

  $('.contacts-nav__item').on('click', () => {
    $('.map-holder__aside-inner').html('');
    $('.map-holder__aside').show();
  })

  const { google } = window;
  const bounds = new google.maps.LatLngBounds();
  const infowindow = new google.maps.InfoWindow();
  const defaultZoom = 10;
  const JSONdate = new Date().toLocaleString().replace(/[^0-9]/g,'');
  const JSONpath = `/map/locations.json?${JSONdate}`;
  // const JSONpath = `../../API/locations.json?${JSONdate}`;
  const markers = [];
  let infoContent = [];
  const dataLink = document.querySelectorAll('.contacts-nav__location li');

  const request = new XMLHttpRequest();
  request.open('GET', JSONpath, true);
  let map;

  const openPopupFunction = (marker, i, data) => {
    google.maps.event.addListener(marker, 'click', (function name() {
      return function name2() {
        const information = data[i].info;
        infowindow.setContent(tooltipTpl(information));
        infowindow.open(map, marker); 
        $('.info-window__item').each(function eachPopups() {
          if ($(this).height() === 0) {
            $(this).hide();
          }
        })
      }
    })(marker, i));
  }

  const showInfoList = (category, data) => {
    $('.map-holder__aside-inner').html('');
    if (Array.isArray(data)) {
      const information = [];
      for (let i = 0; i < data.length; i += 1) {          
        if (data[i].categ === category) {
          information.push(data[i]) 
        }
      }
      $('.map-holder__aside-inner').append(tooltipTpl(information));
      $('.map-holder__aside').show();
    } else if (data.categ === category) {
        const information = data.info;
        $('.map-holder__aside-inner').append(tooltipTpl(information));
        $('.map-holder__aside').show();
      }
  }

  const clickOnTabItem = (hideMarkers, showMarkers) => {
    $('.contacts-nav__item').on('click', function clickOnTabItemHandler() {
      $('.contacts-nav__item').removeClass('active');
      $(this).addClass('active');
      const cat = $(this).data('value');
      const newArr = infoContent.filter(item => item.categ === cat)
      showInfoList(cat, newArr); 
      hideMarkers(markers, cat);
      showMarkers(markers, cat);
      infowindow.close();
      $('.contacts-nav__location').val('all');
    })
  }

  const buildMap = (data) => {
    map = new google.maps.Map(document.getElementById('map'), {
      zoom: defaultZoom,
      styles: mapStyles,
      scrollwheel: false,
      navigationControl: false,
      mapTypeControl: true,
      scaleControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    });

    const iconSrc = {};
    iconSrc.manager = 'front/dist/images/pin-red.png';
    iconSrc.service = 'front/dist/images/pin-blue.png';
    iconSrc.stock = 'front/dist/images/pin-green.png';
    // iconSrc.manager = './images/pin-red.png';
    // iconSrc.service = './images/pin-blue.png';
    // iconSrc.stock = './images/pin-green.png';
    
    if (data.length) {
      for (let i = 0; i < data.length; i += 1) {
        const name = data[i].categ.split(',');
        const coordinate = data[i].coordinates.split(',');
        const coordinateX = coordinate[0];
        const coordinateY = coordinate[1];

        const marker = new google.maps.Marker({
          position: new google.maps.LatLng(coordinateX, coordinateY),
          map,
          icon: iconSrc[name]
        });
        marker.index = i;

        const showMarkers = (catSingle, category) => {
          if (data[i].categ === category) {
            marker.setVisible(true);
          }
        }

        const hideMarkers = (catSingle, category) => {
          if (data[i].categ !== category) {
            marker.setVisible(false);
          }
        }

        clickOnTabItem(hideMarkers, showMarkers, data[i])
        openPopupFunction(marker, i, data)
        markers.push(marker);
        bounds.extend(marker.position);
      }
    }
    
    google.maps.event.addListener(map, 'zoom_changed', () => {
      const zoomChangeBoundsListener =
        google.maps.event.addListener(map, 'bounds_changed', function setZoomMap() {
          if (this.getZoom() > 12 && this.initialZoom === true) {
            this.setZoom(9);
            this.initialZoom = false;
          }
          google.maps.event.removeListener(zoomChangeBoundsListener);
        });
    });
    map.initialZoom = true;
    map.fitBounds(bounds);
    map.panToBounds(bounds);
  };

  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const data = JSON.parse(request.responseText);
      const coordinats =[];
      
      for (const i in data) {       
        const dataAll = data[i].addreses
        for (const j in dataAll) {
          coordinats.push(dataAll[j])
        }
      }
      
      coordinats.filter(item => {
        item.info.forEach(info => {
          infoContent.push(info)
        })
      })

      buildMap(coordinats);
      $('#manager').trigger('click');
      
      const startCoordinates = [];
      const information = [];
      
      for (let i = 0; i < coordinats.length; i += 1) {
        if (coordinats[i].categ === "manager") {
          startCoordinates.push(coordinats[i]);
          return startCoordinates;
        };
      }

      for (let i = 0; i < startCoordinates.length; i += 1) {
        information.push(startCoordinates[i].info);
        return information;
      }

    }
  }
  request.send();

  dataLink.forEach(dataLinkCurrent => {
    dataLinkCurrent.addEventListener('click', () => {
      infoContent = [];
      const dataLinkCurrentValue = dataLinkCurrent.dataset.value;
      if (dataLinkCurrentValue) {
        request.open('GET', JSONpath, true);
        request.onload = () => {
          if (request.status >= 200 && request.status < 400) {
            const data = JSON.parse(request.responseText);
            const coordinats =[];
            const allCoordinats =[];
            
            for (const i in data) {       
              const dataAllName = data[i].region;
              const dataAll = data[i].addreses;
              for (const j in dataAll) {
                if (dataAllName == dataLinkCurrentValue) {
                  coordinats.push(dataAll[j]);
                }
                if (dataLinkCurrentValue == 'all') {
                  coordinats.push(dataAll[j]);
                  allCoordinats.push(dataAll[j]);
                }           
              }
            }
            
            for (let i = 0; i < coordinats.length; i += 1) {           
              const coordinate = coordinats[i].coordinates.split(',');
              const coordinateX = coordinate[0];
              const coordinateY = coordinate[1];
              const boundsC = new google.maps.LatLngBounds();
              const loc = new google.maps.LatLng(coordinateX, coordinateY);
              boundsC.extend(loc);
              map.fitBounds(boundsC)
              map.setZoom(10);
            }

            coordinats.filter(item => {
              item.info.forEach(info => {
                infoContent.push(info)
              })
            })

            $('.map-holder__aside-inner').html(tooltipTpl(infoContent));
            $('.map-holder__aside').show();

            if (allCoordinats.length > 0) {
              $('.contacts-nav__item').removeClass('active');
              buildMap(coordinats);
            }
          }
        }
        request.send();
      }
    })
  });

  $('.map-holder__close-button').on('click', () => {
    $('.map-holder__aside').hide();
  })
  
};  


// WEBPACK FOOTER //
// app/scripts/components/map.js